import useUIState from './persistUiState';
import { GroupState, TodoUIState } from './types';

export const useTodoUIState = (groupId: string): TodoUIState =>
  useUIState((state) => ({
    groupState: state.toDoGroupStates[groupId],
    setGroupState: (todoStates: Partial<GroupState>) => {
      state.setToDoGroupState(groupId, todoStates);
    },
  }));
